module.exports = __webpack_public_path__ + "static/media/example02-01.9e7f0b97.svg";